export default {
	CorrectAnswer: 'correctAnswer',
	NoAnswer: 'noAnswer',
	ChooseAnswer: 'chooseAnswer',
}
